// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"50c19b6c","335":"a2a19718","453":"3c94912c","491":"ab88c9ea","556":"4a2a16bd","632":"57331b28","678":"63d69b4b","694":"26347cab","825":"895ac808"}[chunkId] + ".chunk.js";
};